import { ColumnType, EventColumnEnum } from "../../enums/DRCXEnums";

export function makeEventColumnEquatableKey(
    eventColumn: EventColumnEnum
): string {
    return `${ColumnType.Event}:${typeof eventColumn === "number" ? eventColumn : ""}`;
}
